import React from 'react';

export const IconCheckMark = ({ width, height }) => {

  const styles = {
    frame: {
      display: 'inline-block',
      width,
      height
    },
    container: {
      display: 'inline-block',
    },
    svg: {
      width: '100%',
    }
  }

  return (
    <div style={styles.frame}>
      <div style={styles.container} className="menu-button-icon-bubbles">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" version="1.1" className="ok-icon" style={styles.svg}>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="icons" transform="translate(-562.000000, -739.000000)">
              <g transform="translate(562.000000, 739.000000)">
                <path
                  d="M13,26 C5.82033333,26 0,20.1796667 0,13 C0,5.82033333 5.82033333,0 13,0 C20.1796667,0 26,5.82033333 26,13 C26,20.1796667 20.1796667,26 13,26 Z"
                  className="circle"
                  fill="#767676"
                />
                <polygon
                  fill="#FFFFFF"
                  points="9.8252 19.5014667 5.29286667 14.9691333 6.7072 13.5551333 9.8252 16.6734667 19.2928667 7.20546667 20.7072 8.61946667"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  )
};